import { motion } from 'framer-motion';
export default function AboutCompany() {
  return (
    <section className="relative mt-[3rem] w-full overflow-hidden font-inter md:mt-[6rem]">
      {/* --- IMAGE ON LEFT EDGE --- */}
      <motion.div
        className="inset-y-0 left-0 hidden w-full rounded-md md:block lg:absolute lg:w-[45vw]"
        initial={{ x: -200, opacity: 0 }} // start off to the left, invisible
        whileInView={{ x: 0, opacity: 1 }} // move to original position and fade in
        transition={{ duration: 0.8, ease: 'easeOut' }} // adjust speed
        viewport={{ once: true, amount: 0.5 }} // trigger once when 50% in view
      >
        <img
          src="/newwelcome.jpg"
          className="h-full w-full rounded-md object-cover object-[30%_0%]"
          alt="constructor"
        />
      </motion.div>
      <img
        src="/newwelcome.jpg"
        className="block h-full w-full rounded-md object-cover object-[30%_0%] md:hidden"
        alt="constructor"
      />
      {/* --- MAIN CONTENT MAX WIDTH --- */}
      <div className="relative mx-auto flex max-w-[116rem] pl-[2rem] pr-[2rem] lg:pl-[12rem] lg:pr-[2rem]">
        {/* RIGHT TEXT COLUMN (shifted to right of image) */}
        <div className="mt-[3rem] w-full pr-[2rem] lg:ml-auto lg:mt-0 lg:w-[57rem]">
          <motion.h1
            initial={{ opacity: 0, x: 400 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.5 }} // triggers when 50% in view
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="text-[1.6rem] font-[600] leading-[2.6rem] text-[#0EC9AC] md:pt-[8rem] md:text-[1.8rem] md:leading-[2.8rem]"
          >
            Welcome to NEXT-G Services
          </motion.h1>

          <h1 className="mt-[2rem] text-[2.4rem] font-[600] leading-[3.2rem] text-white lg:text-[3.6rem] lg:leading-[4.6rem]">
            The modern answer to your security needs
          </h1>

          <p className="mt-[3rem] text-[1.6rem] font-[400] leading-[2.4rem] text-[#999]">
            NEXT-G Services provides professional, reliable security solutions for businesses across
            the UK. From corporate offices and construction sites to hotels and events, our
            SIA-licensed teams protect what matters most — your people, your property and your
            reputation.
          </p>
          <div className="mt-[4rem] flex w-full justify-between">
            <div className="flex w-[48.5%] flex-col gap-[2rem]">
              <img
                src="/highqualityservice.png"
                alt="high quality service"
                className="h-[4rem] w-[4rem]"
              />
              <h1 className="text-[2.4rem] font-[600] leading-[3.2rem] text-white">
                High Quality Service
              </h1>
              <p className="text-[1.6rem] leading-[2.4rem] text-[#999]">
                We combine experienced, vetted security professionals with clear communication and
                responsive support. Every contract is managed proactively, with regular reviews to
                ensure our service consistently meets your standards.
              </p>
            </div>
            <div className="flex w-[48.5%] flex-col gap-[2rem]">
              <img
                src="/effectiveprotection.png"
                alt="effective protection"
                className="h-[4rem] w-[4rem]"
              />
              <h1 className="text-[2.4rem] font-[600] leading-[3.2rem] text-white">
                Effective Protection
              </h1>
              <p className="text-[1.6rem] leading-[2.4rem] text-[#999]">
                Our security solutions are designed around real risks, not guesswork. Through smart
                planning, visible presence and rapid response, we help deter crime, reduce incidents
                and create a safer environment for staff, visitors and customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
